
import { useState, useEffect } from 'react';

interface MaintenanceModeProps {
  isActive: boolean;
  onToggle: (active: boolean) => void;
}

export default function MaintenanceMode({ isActive, onToggle }: MaintenanceModeProps) {
  if (!isActive) return null;

  return (
    <div className="fixed inset-0 bg-white z-50 flex items-center justify-center">
      <div className="max-w-2xl mx-auto px-6 text-center">
        {/* 维护图标 */}
        <div className="mb-8">
          <div className="w-24 h-24 mx-auto bg-gradient-to-r from-blue-500 to-blue-600 rounded-full flex items-center justify-center">
            <i className="ri-tools-line text-4xl text-white"></i>
          </div>
        </div>

        {/* 标题 */}
        <h1 className="text-4xl font-bold text-gray-800 mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
          璀璨珠宝
        </h1>
        
        <h2 className="text-2xl font-semibold text-gray-700 mb-6">
          网站维护中
        </h2>

        {/* 维护说明 */}
        <div className="bg-blue-50 rounded-lg p-6 mb-8">
          <p className="text-gray-600 text-lg mb-4">
            我们正在对网站进行升级维护，为您提供更好的购物体验。
          </p>
          <p className="text-gray-600">
            预计维护时间：2-4小时
          </p>
          <p className="text-gray-600">
            维护期间如有紧急需求，请通过以下方式联系我们：
          </p>
        </div>

        {/* 联系方式 */}
        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
            <div className="w-12 h-12 mx-auto bg-blue-100 rounded-full flex items-center justify-center mb-3">
              <i className="ri-phone-line text-blue-600 text-xl"></i>
            </div>
            <h3 className="font-semibold text-gray-800 mb-2">电话咨询</h3>
            <p className="text-gray-600">400-888-8888</p>
            <p className="text-sm text-gray-500">工作时间：10:00-22:00</p>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
            <div className="w-12 h-12 mx-auto bg-green-100 rounded-full flex items-center justify-center mb-3">
              <i className="ri-wechat-line text-green-600 text-xl"></i>
            </div>
            <h3 className="font-semibold text-gray-800 mb-2">微信客服</h3>
            <p className="text-gray-600">cuican_jewelry</p>
            <p className="text-sm text-gray-500">24小时在线</p>
          </div>

          <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
            <div className="w-12 h-12 mx-auto bg-purple-100 rounded-full flex items-center justify-center mb-3">
              <i className="ri-mail-line text-purple-600 text-xl"></i>
            </div>
            <h3 className="font-semibold text-gray-800 mb-2">邮箱联系</h3>
            <p className="text-gray-600">service@cuican.com</p>
            <p className="text-sm text-gray-500">24小时内回复</p>
          </div>
        </div>

        {/* 社交媒体 */}
        <div className="flex justify-center space-x-4 mb-8">
          <a href="#" className="w-10 h-10 bg-blue-600 text-white rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
            <i className="ri-wechat-fill"></i>
          </a>
          <a href="#" className="w-10 h-10 bg-red-600 text-white rounded-full flex items-center justify-center hover:bg-red-700 transition-colors cursor-pointer">
            <i className="ri-weibo-fill"></i>
          </a>
          <a href="#" className="w-10 h-10 bg-gray-800 text-white rounded-full flex items-center justify-center hover:bg-gray-900 transition-colors cursor-pointer">
            <i className="ri-douyin-fill"></i>
          </a>
        </div>

        {/* 管理员控制 */}
        <div className="border-t border-gray-200 pt-6">
          <button
            onClick={() => onToggle(false)}
            className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 transition-colors cursor-pointer"
          >
            关闭维护模式（管理员）
          </button>
        </div>

        {/* 底部信息 */}
        <div className="mt-8 text-sm text-gray-500">
          <p>感谢您的耐心等待，我们将尽快恢复服务</p>
          <p className="mt-2">© 2024 璀璨珠宝 版权所有</p>
        </div>
      </div>
    </div>
  );
}
